/**
 * Shared formatting utility functions
 */

/**
 * Format a number with K/M suffixes for compact display
 * @param {number} num - The number to format
 * @returns {string} Formatted number string
 */
export function formatNumber(num) {
  if (!num) return '0';
  if (num >= 1000000) return `${(num / 1000000).toFixed(1)}M`;
  if (num >= 1000) return `${(num / 1000).toFixed(1)}K`;
  return num.toLocaleString();
}

/**
 * Truncate an Ethereum address for display (e.g. 0x1234...5678)
 * @param {string} address - The full address
 * @returns {string} Truncated address
 */
export function truncateAddress(address) {
  if (!address) return '';
  return `${address.slice(0, 6)}...${address.slice(-4)}`;
}
